import { useContext } from 'react'
import Header from 'components/header'
import Footer from 'components/footer'
import Loader from 'components/loader'
import { Container } from '../../../styles/global'
import { RootContext } from '../../../context/rootContext'
import WarningModal from 'components/warningModal'
import ActionModal from 'components/actionModal'
import ModalSheet from 'components/modalSheet'

const DefaultLayout = ({ children }) => {
  const { isReactNative, modalSheetProps: { currentModal }, toggleModalSheet, warningModalProps } = useContext(RootContext)

  return (
    <>
      <Header />
      <Container paddingTop={62}>
        {children}
      </Container>
      <Loader />
      <ActionModal />
      <ModalSheet
        visible={currentModal.visible}
        showBackButton={currentModal.showBackButton}
        showCloseButton={currentModal.showCloseButton}
        title={currentModal.title}
        subtitle={currentModal.subtitle}
        decentralizedSubTitle={currentModal.decentralizedSubTitle}
        largeHeaderGap={currentModal.largeHeaderGap}
        onCancel={currentModal.onCancel ?? toggleModalSheet}
        icon={currentModal.icon}
        iconSize={currentModal?.iconSize}
        dataTest='modal-sheet_auth'
        modalWidth={currentModal?.modalWidth}
        modalHeight={currentModal?.modalHeight}
        children={currentModal?.children}
      />
      <WarningModal {...warningModalProps} />
      <Footer isReactNative={isReactNative} />
    </>
  )
}

export default DefaultLayout
